import {preloadProductCarouselImages} from '@/product/preload-product-carousel-images';
import {getProductSelection} from '@/product/product-selection';
import {loadProductJson} from '@/product/product-selection/load-product-json';
import {h} from 'preact';
import register from 'preact-custom-element';
import ProductImageCarousel from './ProductImageCarousel';

function loader({
  product: productJson,
  aspectRatio,
}: ProductImageCarouselLoaderProps) {
  loadProductJson(productJson);

  const {product, selectedVariant} = getProductSelection();
  const images = product
    ? preloadProductCarouselImages({product, selectedVariant})
    : [];

  return images.length > 0
    ? h(ProductImageCarousel, {
        images,
        featured: images[0],
        aspectRatio,
      })
    : null;
}

register(loader, 'product-image-carousel', ['product']);

type ProductImageCarouselLoaderProps = {
  product: string;
  aspectRatio?: string;
};
